<template>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="库存日期">
        <el-date-picker v-model="form.fDate" type="date" value-format="yyyy-MM-dd" style="width:100%;" />
      </el-form-item>
      <el-form-item label="批号" prop="fBatchNo">
        <el-input v-model="form.fBatchNo" />
      </el-form-item>
      <el-form-item label="生产日期" prop="fDate_Sc">
        <el-date-picker v-model="form.fDate_Sc" type="date" value-format="yyyy-MM-dd" style="width:100%;" />
      </el-form-item>
      <el-form-item label="消毒日期">
        <el-date-picker v-model="form.fDate_Xd" type="date" value-format="yyyy-MM-dd" style="width:100%;" />
      </el-form-item>
      <el-form-item label="追溯号">
        <el-input v-model="form.fRetroactiveNo" />
      </el-form-item>
      <el-form-item label="数量">
        <el-input-currency v-model="form.fQty" :scale="0" min="0" />
      </el-form-item>
    </el-form>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fBatchNo: [{ required: true, message: '必填项', trigger: 'change' }],
        fDate_Sc: [{ required: true, message: '必填项', trigger: 'change' }],
      }
    }
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    }
  }
}
</script>
